import { api } from "@/lib/apiClient";

export interface IntegrationsStatus {
  email: {
    provider: string;
    from_address: string | null;
    smtp_host: string | null;
    smtp_password_configured: boolean;
  };
  fernauslese: {
    enabled: boolean;
    base_url: string | null;
    api_username: string | null;
    api_password_configured: boolean;
  };
  device_service: {
    enable_zvt: boolean;
    base_url: string | null;
    api_key_configured: boolean;
  };
  tse: {
    enabled: boolean;
    configured: boolean;
    provider: string;
  };
  barrier: {
    enabled: boolean;
    configured: boolean;
    provider: string;
  };
  lpr: {
    enabled: boolean;
    configured: boolean;
    provider: string;
  };
  stripe?: {
    configured: boolean;
    secret_key_configured: boolean;
    webhook_secret_configured: boolean;
    secret_key_source: "settings" | "environment" | null;
    mode: "test" | "live" | null;
  };
  integrations: {
    pms_import_email: string | null;
    google_places_api_key_configured: boolean;
    api_keys: { id: string; name: string }[];
    tourist_integration?: { enabled?: boolean };
  };
}

export async function getIntegrationsStatus(): Promise<IntegrationsStatus> {
  return api.get<IntegrationsStatus>("/api/v1/settings/integrations-status");
}
